import React from "react";
import { Loader2, Pencil, Trash2 } from "lucide-react";

interface RowActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  editing?: boolean;
  deleting?: boolean;
  disabled?: boolean;
}

export const RowActions: React.FC<RowActionsProps> = ({
  onEdit,
  onDelete,
  editing,
  deleting,
  disabled,
}) => (
  <div className="flex items-center justify-end gap-1">
    {onEdit && (
      <button
        type="button"
        onClick={onEdit}
        disabled={disabled || editing}
        className="inline-flex items-center gap-1 rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 disabled:opacity-50"
        title="Edit"
      >
        {editing ? <Loader2 className="h-4 w-4 animate-spin" /> : <Pencil className="h-4 w-4" />}
      </button>
    )}
    {onDelete && (
      <button
        type="button"
        onClick={onDelete}
        disabled={disabled || deleting}
        className="inline-flex items-center gap-1 rounded-md p-1.5 text-gray-500 hover:bg-red-50 hover:text-red-600 disabled:opacity-50"
        title="Delete"
      >
        {deleting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
      </button>
    )}
  </div>
);
